import React from 'react';
import BootstrapProgressBar from 'react-bootstrap/ProgressBar';

import styles from './ProgressBar.module.scss';

const ProgressBar = ({ percentage = 0, heading = 'Heading' }) => (
  <div className={styles.rootConatiner}>
    <div className={styles.headingContainer}>
      <span className={styles.heading}>{heading}</span>
      <span className={styles.progress}>{percentage}%</span>
    </div>
    <div className={styles.barContainer}>
      <BootstrapProgressBar now={percentage} />
    </div>
  </div>
);

export default ProgressBar;
